import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ Get Shopify Locations -------
const getShopifyLocations = async () => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.shopify.locations);
    return data;
};

const GetShopifyLocationsQuery = (options = {}) => {
    return useQuery(['ShopifyLocations'], () => getShopifyLocations(), {
        staleTime: Infinity,
        cacheTime: 1000 * 60 * 60, // 1 hour cache
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: false,
        ...options
    });
};

// ------------------ Update Shopify Location Warehouse -------
const updateShopifyWarehouse = async ({ warehouse_id, shopify_location_id }) => {
    console.log("Mutation Payload Check:", { warehouse_id, shopify_location_id });
    // PATCH /api/warehouse/map-location/:warehouseId  { shopify_location_id }
    return await HTTP_CLIENT.patch(`${Endpiont.warehouse.mapLocation}/${warehouse_id}`, {
        shopify_location_id
    });
};

const UpdateShopifyWarehouseMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateShopifyWarehouse, {
        onSuccess: () => {
            queryClient.invalidateQueries('ShopifyLocations');
            toastMessage('success', 'Warehouse linked successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Server Error');
        }
    });
};

// ------------------ Sync Shopify Inventory -------
const syncShopify = async () => {
    return await HTTP_CLIENT.post(Endpiont.shopify.sync);
};

const SyncShopifyMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(syncShopify, {
        onSuccess: () => {
            queryClient.invalidateQueries('ShopifyLocations');
            toastMessage('success', 'Shopify sync started successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            toastMessage('error', desc || 'Sync failed');
        }
    });
};

export { GetShopifyLocationsQuery, UpdateShopifyWarehouseMutation, SyncShopifyMutation };
